import { render, staticRenderFns } from "./SIPortalPendidikan.vue?vue&type=template&id=a617f8ca&"
import script from "./SIPortalPendidikan.vue?vue&type=script&lang=js&"
export * from "./SIPortalPendidikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports